<template>
    <div>
        <Collapse v-model="value1" size="small">
            <Panel name="1" size="small" class="cpllapse-panel-title">
                最新文件
                <div slot="content">
                    <Row :style="{display:isShowSearchBar?'block':'none'}">
                        <div style="float: left">
                            <DatePicker type="daterange" split-panels format="yyyy-MM-dd" placement="bottom-end" style="padding-left: 5px;" placeholder="请选择时间范围" :editable="false" v-model="timeZone" confirm @on-change="timeOnChange"></DatePicker>
                        </div>
                        <div style="float: left;padding-left: 10px;"><Input v-model="text" :maxlength="searchTextMaxlength" search enter-button="查询" @on-search="nextSearch" placeholder="请输入文件名关键字..." /></div>
                    </Row>
                    <br />
                    <div class="demo-spin-container">
                        <LastFiles ref="search_rlt" :tData="nData" @onPageChange="pageChange" @selectUpload-checked="tableRowChecked"></LastFiles>
                        <div v-if="show">
                            <br />
                            <Tag color="success" closable @on-close="handleClose">
                                小提示：分类使用文件,建议您将文件上传至"智慧云端—上传文件库"中，便于随时查阅。
                            </Tag>
                        </div>
                        <div v-if="flag">
                            <ResultTag ref="tableTag1" :sTreeData="tagData" :sTreeIndustry="sTreeIndustry" :streeProvince="streeProvince" :isCountryNew=true @onTagchanged="childTagChange" @on-show-checkbox="showCheckBox" @clean-checked="clearCheckList" @on-submit-checked="onSubmitChecked" @on-one-key-upload="onOneKeyLastFilesUpload" @on-folder-selected-upload="onSelectedUploadReady"></ResultTag>
                        </div>
                        <br />
                        <!--  <Button type="text" size="small" to="/main/cloud/mycloud?q_type=mycloud" ghost>"我的云端—上传文件夹"</Button> -->
                    </div>
                    <!-- <Row>
            <Col v-for="index in items"  :key="index" span="4">
            <TreeTag :tData="sTreeData" class="common-width"></TreeTag>
            </Col>
          </Row> -->
                    <!--  <div class="div-inline" v-for="item in items"> <TreeTag :tData="sTreeData" class="common-width"></TreeTag></div> -->
                </div>
            </Panel>
        </Collapse>
        <Divider orientation="left" dashed id="dividerDesc">搜索引擎</Divider>
        <SearchMain @on-searchMain-search="onSearchMainSearch" @onEngineSearch="onEngineSearch" @onTradeSearch="onTradeSearch" @onTreatySearch="onTreatySearch"></SearchMain>
        <Modal v-model="isShowProgressBox" @on-ok="onProgressOK" @on-cancel="onProgressCancel" :mask-closable="false" :closable="false">
            <p slot="header" :style="{color:titletheme}" style="text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{uploadTitle}}</span>
            </p>
            <div><Progress :percent="uploadpercent" :stroke-width="20" status="active" text-inside /></div>
            <div slot="footer">
                <Button :type="buttonTheme" :disabled="isActiveButton" size="large" @click="onProgressOK">{{progressBoxButtonText}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import SearchMain from '../common_engine/search_main.vue'
import tableresult from './resulttable.vue'
import testData2 from '../../../assets/json/testTableData2.json'
import TreeTag from '../../common/tree-single-select.vue'
import TreeMultiTag from '../../common/tree-select.vue'
import ReadMore from '../../common/readmore.vue'
import ResultTag from './resultTag.vue'

// import treeData from '../../../../static/api/selected-tree.json'
// import treeIndustryData from '../../../../static/api/selected-tree-industry.json'
import treeTradeData from '../../../assets/json/selected-tree-trade.json'
import TagCityData from '../../../assets/json/tagCity.json'
import More from "../../../api/common/more.js"
import { mapGetters } from 'vuex'
import ConstJson from "../../../api/common/constjson.js"
let MoreFun = new More()
let constJ = new ConstJson()
let parents = null
let childNode = null
let currentDeep = 0
export default {
    name: 'SearchEngineIndex',
    inject: ["reload", "getSliders", "showMain"],
    data() {
        return {
            searchTextMaxlength: 100,
            value1: "1",
            nData: {}, //this.handle_getNewFiles(1),
            tagData: {}, //this.getTreeData(),
            sTreeIndustry: this.getIndustryData(0),
            streeProvince: this.getProvince(),
            timeZone: ['', ''], //['2016-01-01', '2016-02-15'],
            show: true,
            flag: false,
            currentNode: {},
            text: "",
            classid: "",
            sliders: this.getSliders(),
            isShowSearchBar: true,
            isShowProgressBox: false, //上传对话框
            uploadpercent: 0, //上传进度
            isPollingStop: false, //暂停轮询
            uploadTitle: '稍候片刻,请静待上传完成', //提示信息
            titletheme: '#2d8cf0', //提示信息颜色
            errorStatus: '', //错误状态
            progressBoxButtonText: '确定', //确定按钮文字
            isActiveButton: true, //是否禁用按钮
            buttonTheme: 'success', //按钮样式
            disconnectTimes: 0, //网络连接失败，20次后进度条按钮可以关闭
            //isTempLogin:false,
            isFirstSerach: true,
            isfilter: false,
            defaultTagpc: [{ p: '000000', c: '000000' }],
        }
    },
    components: {
        'SearchMain': SearchMain,
        'LastFiles': tableresult,
        'ResultTag': ResultTag,

    },
    created() {
        this.showMain(false)
        //console.log("created,isLogin:"+this.sta.isLogin)
        // this.$nextTick(function() {
        if (this.isTempLogin === true && this.sta.userGuid !== '') {
            var id = this.$route.query.classid
            this.handle_getNewFiles(1, id)
        }

        //获取所有最新数据
        //this.getAllLastNewFiles(1,id)

        // })
    },
    computed: {
        ...mapGetters(['sta']),
        isTempLogin: function() {
            //console.log(this.sta.isLogin)
            return this.sta.isLogin
        }
    },
    watch: {
        tagData: function() {
            //console.log(this.tagData)
        },
        isTempLogin: function() {
            //console.log("isTempLogin:"+this.isTempLogin)
            if (this.isTempLogin === true) {
                var id = this.$route.query.classid
                this.handle_getNewFiles(1, id)
            }

        },
        sliders: function(v) {
            var id = this.$route.query.classid === undefined ? "" : this.$route.query.classid
            var tagid = this.currentNode.id === undefined ? "" : this.currentNode.id
            //console.log('id：'+id)
            //多屏还原到单屏时判断id来动态显示或隐藏文号字段
            if (id.startsWith('000007000002') || tagid.startsWith('000007000002')) {
                this.$refs.search_rlt.onSlidersChanged(MoreFun.getColumns().treaty)
            } else {
                this.$refs.search_rlt.onSlidersChanged()
            }
        }
    },
    methods: {
        // showDialog2() {
        //     let that = this
        //     this.$Modal.confirm({
        //         title: '提示',
        //         //content: '<p>' + content + '</p>',
        //         render: h => {
        //             return h('span', [
        //                 '',
        //                 h('span', {
        //                     domProps: {
        //                         innerHTML: `<span style="color:#515a6e;font-size:14px;" >关闭一键上传进度显示,系统仍然会持续完成文件上传任务，确认关闭吗?</span>`,
        //                     }
        //                 }), ''
        //             ])
        //         },
        //         okText: '确认',
        //         cancelText: '取消',
        //         onOk: () => {
        //             this.isPollingStop = true
        //             this.isShowProgressBox = false
        //         },
        //         onCancel: () => {
        //             if (this.uploadpercent === 100 || this.isPollingStop) {
        //                 this.isShowProgressBox=false
        //             }else{
        //                  this.isShowProgressBox=true
        //             }
        //             return
        //             // this.$Message.info('Clicked cancel');
        //         }
        //     });
        // },
        onProgressCancel() {
            // if (this.uploadpercent === 100 || this.isPollingStop) {
            //     this.isPollingStop = true
            //     this.isShowProgressBox = false
            // } else {

            //     this.showDialog2()
            // }
        },
        onProgressOK() {
            // if (this.uploadpercent === 100 || this.isPollingStop) {
            //     this.isPollingStop = true
            //     this.isShowProgressBox = false
            // } else {
            //     this.showDialog2()
            // }
            //console.log("onProgressOK...")
            this.isPollingStop = true
            this.isShowProgressBox = false
        },
        onSearchMainSearch() {
            this.value1 = ""
            this.scrollIntoViewResult()
        },
        tagTipsClose() {
            //console.log("tagTipsClose...")
            this.$refs.tableTag1.tipClose()
        },
        //选择性上传的数据
        // getTagChecked(){
        //   let docIdList = []//需要提交给后端插入云端
        //   let checkedBox = this.$refs.search_rlt.getChecked()
        //   if (checkedBox.length > 0) {
        //     for (let i = 0; i < checkedBox.length; i++) {
        //       docIdList.push(checkedBox[i].docid)
        //     }
        //   }
        //   return docIdList
        // },
        onSubmitChecked(folderid) {
            //提交数据用户已选择的文件
            let count = this.$refs.search_rlt.showListTotal()
            let checked = this.$refs.search_rlt.getDocIdChecked()
            //console.log("submit to cloud======>")
            //console.log(checked)
            if (checked.length > 0) {
                console.log("选择上传到文件夹:" + folderid)
                this.upLoadFileToCloud(checked, folderid)
            } else {
                this.$Message.warning("没有选择文件")
            }

            //console.log(checked)
            //this.$Message.success("提交成功(" + count + ")")
            this.clearCheckList()
            //还原searchbar为显示状态
            this.isShowSearchBar = true

        },
        clearCheckList() {
            this.$refs.search_rlt.clearChkList()
        },
        tableRowChecked(listCount) {
            this.$refs.tableTag1.showBtnTxt(listCount)
        },
        showCheckBox(value) {
            //隐藏小贴士
            this.show = !value
            this.$refs.search_rlt.showCheckBox(value)
        },
        getTableData() {
            // this.handle_getNewFiles()
            // var id=this.$route.query.classid
            // console.log(id)
            // return testData2
        },
        getTreeData() {

        },
        getProvince() {
            // this.$API.getTestCity().then(res=>{
            //     console.log(res)
            // })
            return TagCityData
        },
        getIndustryData(node) {
            if (node === 0) {
                node = { "data": [{ "label": "进出口税收管理类", "id": "001" }] }
            }
            // this.sTreeIndustry=node
            // return treeIndustryData
            return node
        },
        nextSearch() {
            //this.reload();
            //console.log(this.timeZone)
            // let data = sessionStorage.getItem('st');
            // console.log(JSON.parse(data))
            this.currentNode = {}
            this.isfilter = false
            if (this.timeZone[0] === "" && this.timeZone[1] === "" && this.text === "") {
                this.isFirstSerach = true
            } else {
                this.isFirstSerach = false
            }

            // if (this.currentNode.id === undefined) {
            //     this.currentNode.id = this.classid
            // }

            this.handle_getNewFiles(1, this.classid, this.currentNode.id, this.timeZone, this.text)
        },
        onEngineSearch(searchData) {
            this.value1 = ""
            this.scrollIntoViewResult()
            // console.log(searchData)

        },
        scrollIntoViewResult() {
            var element = document.getElementById("dividerDesc");
            element.scrollIntoView();
        },
        onTradeSearch() {
            this.value1 = ""
            this.scrollIntoViewResult()
        },
        onTreatySearch() {
            this.value1 = ""
            this.scrollIntoViewResult()
        },

        onTagChange() {

        },
        timeOnChange() {
            var time = []
            if (this.timeZone[0] !== "") {
                time[0] = MoreFun.getFormattedDate(this.timeZone[0])
                time[1] = MoreFun.getFormattedDate(this.timeZone[1])
                this.timeZone = time
            } else {

            }
        },
        onSelectedUploadReady() {
            this.isShowSearchBar = false
        },
        getOneKeyUploadProgress(id) {
            console.log("request progress id:" + id)
            constJ.reqGetOneKey_UploadProgress_V2(id).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        let total = res.item.total
                        let complete = res.item.complete
                        let per = 0
                        if (total > 0) {
                            per = parseInt((complete / total) * 100)
                        } else {
                            this.$Message.error("总计上传条数为零");
                            return
                        }
                        this.uploadpercent = per
                    } else {
                        this.$Message.error(res.rltdesc);
                        this.isShowProgressBox = false
                        this.isPollingStop = true
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    this.isShowProgressBox = false
                    this.isPollingStop = true
                    return
                }
            }).catch(error => {
                if (!error.response) {
                    // network error
                    //this.errorStatus = 'Error: Network Error';

                    // this.isShowProgressBox = false
                    // this.isPollingStop = true
                    if (this.disconnectTimes <= 20) {
                        this.disconnectTimes++;
                    } else {
                        this.uploadTitle = "您的网络连接异常,请勿担心,系统仍然会持续完成文件上传任务"
                        this.titletheme = "#ff9900"
                        this.buttonTheme = 'warning'
                        this.isActiveButton = false
                    }
                    this.$Message.error("网络连接异常");
                } else {
                    this.errorStatus = error.response.data.message;
                    this.isShowProgressBox = false
                    this.isPollingStop = true
                    this.$Message.error(this.errorStatus);
                }
                //console.log( this.errorStatus)
            })
        },
        autoPollingOneKeyProgress(id) {
            //状态初始化
            this.uploadpercent = 0
            this.isPollingStop = false
            this.uploadTitle = "稍候片刻,请静待上传完成"
            this.titletheme = "#2d8cf0"
            this.isActiveButton = true
            this.buttonTheme = "success"
            this.disconnectTimes = 0
            // this.progressBoxButtonText="关闭进度显示"
            let clock = window.setInterval(() => {
                this.getOneKeyUploadProgress(id)
                if (this.uploadpercent === 100 || this.isPollingStop) {
                    this.uploadTitle = "文件上传成功,谢谢您的耐心等待"
                    this.titletheme = "#19be6b"
                    this.isActiveButton = false
                    this.buttonTheme = "success"
                    //this.progressBoxButtonText="确定"
                    console.log("clearInterval...")
                    window.clearInterval(clock)
                }
            }, 1000)
        },
        onOneKeyLastFilesUpload(folderid) {
            //classid,tagid,timezone,text
            var item = {}
            item.classid = this.classid
            item.tagid = this.currentNode.id
            item.timeZone = this.timeZone
            item.text2 = this.text
            item.folderid = folderid
            item.fs = this.isFirstSerach
            item.ft = true //this.isfilter
            item.tagpc = this.defaultTagpc
            console.log("一键上传到文件夹:" + folderid)
            console.log(item)
            constJ.reqOneKeyLastFiles_V2(item).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {

                        //启动定时器
                        //this.autoPollingOneKeyProgress()
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                            //this.getOneKeyUploadProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }
                        //this.$Message.success("一键上传成功")
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },

        upLoadFileToCloud(idList, folderid) {
            // let docids=[]
            // docids.push(parseInt(this.text))
            constJ.upLoadFileToCloud(idList, folderid).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success("已上传" + idList.length + "个文件至云端")
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})


        },

        // getAllLastNewFiles(currentIndex, classid, tagid, timeZone, text) {
        //     console.log("request new files ...")
        //     var class_id = classid
        //     tagid = tagid === undefined ? "" : tagid
        //     var params = {
        //         pagesize: 100,
        //         pageindex: currentIndex,
        //         id: class_id,
        //         tagid: tagid,
        //         stime: timeZone !== undefined ? timeZone[0] : "",
        //         etime: timeZone !== undefined ? timeZone[1] : "",
        //         text: "",
        //         text2: text,
        //         fs: this.isFirstSerach,
        //     }
        //     constJ.reqGetLasFiles(params).then(res => {
        //         console.log(res)
        //         if (res.tbls[0].total > 0) {

        //         }
        //     })
        //     // constJ.reqGetLasFiles(100, currentIndex, id, tagid, timeZone, text).then(res => {
        //     //     console.log(res)
        //     //     if (res.tbls[0].total > 0) {

        //     //     }
        //     // })
        // },

        handle_getNewFiles(currentIndex, classid, tagid, timeZone, text) {
            var class_id = classid
            tagid = tagid === undefined ? "" : tagid
            //000007000002 =国家(地区)以及自己得国家,不显示文号字段
            // this.$Loading.start();

            var params = {
                pagesize: 8,
                pageindex: currentIndex,
                id: class_id,
                tagid: tagid,
                stime: timeZone !== undefined ? timeZone[0] : "",
                etime: timeZone !== undefined ? timeZone[1] : "",
                text: "",
                text2: text,
                fs: this.isFirstSerach,
                isfilter: this.isfilter,
                tagpc: this.defaultTagpc,
            }
            // constJ.reqGetLasFiles(10, currentIndex, id, tagid, timeZone, text, this.isFirstSerach)
            constJ.reqGetLasFiles(params).then(res => {
                //console.log("reqGetLasFiles..."+"id:"+id+",tagid:"+tagid)
                console.log(res)
                var obj = null
                if (res.tbls[0].total > 0) {
                    obj = {
                        header: testData2.header,
                        tabrows: res.tbls[0].items,
                        total: res.tbls[0].total,
                        classid: classid,
                        tabname: "newfiles",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext:res.tbls[0].warningtext,
                        protect:res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                        showColumns: classid.startsWith('000007000002') || tagid.startsWith('000007000002') ? MoreFun.getColumns().treaty : []
                    }
                } else {
                    //默认
                    obj = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        classid: classid,
                        tabname: "newfiles",
                        tags: res.tbls[0].classifytag,
                        level: res.tbls[0].divisiontag,
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext:res.tbls[0].warningtext,
                        protect:res.tbls[0].protect,
                        tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: currentIndex,
                        showColumns: [],
                    }
                }

                // if (obj.tags.length === 1 && obj.tags[0].children.length > 0) {
                //   var _obj = {
                //     data: obj.tags[0].children
                //   }
                // } else if (obj.tags.length > 1) {
                //   var _obj = {
                //     data: obj.tags
                //   }
                // }


                //绑定列表
                this.$refs.search_rlt.show(obj)
                //绑定tag
                var _obj = MoreFun.getTag(obj.tags)
                var tempTag = {
                    tags: _obj,
                    status: obj.tagstatus,
                    total: obj.total,
                    level: obj.level,
                    warninglevel:obj.warninglevel,
                    warningtext:obj.warningtext,
                    protect:res.tbls[0].protect,
                }
                this.tagData = tempTag
                this.flag = true
                //console.log(this.tagData)
                // return obj
                // this.$Loading.finish();
            }).catch(err => {
                // this.$Loading.error()
                // console.log(err)
                // // console.log("err:"+err.statusCode)
                // console.log("statusCode:"+err.statusCode)
                // console.log("rlt:"+err.error.rtncode)


            })
        },
        pageChange(index, tabname) {
            //console.log(tabname)
            if (tabname === "newfiles") {
                //this.handle_getNewFiles(index, this.classid, this.currentNode.id)
                //console.log(this.currentNode.id===undefined)

                // if (this.currentNode.id === undefined) {
                //     this.currentNode.id = this.classid
                // }

                this.handle_getNewFiles(index, this.classid, this.currentNode.id, this.timeZone, this.text)
            }

        },

        childTagChange(node) {
            // console.log("request node=====>" + node.id)
            // console.log("request classid=====>" + this.classid)
            //this.isFirstSerach = false
            this.isfilter = true
            this.currentNode = node
            this.handle_getNewFiles(1, this.classid, node.id, this.timeZone, this.text)
            //this.$refs.search_rlt.changePage()
        },
        handleClose() {
            this.show = false;
        },

    },
    mounted: function() {
        this.classid = this.$route.query.classid
        //console.log(this.classid)
    },
}
</script>
<style scoped>
/*//深度选择器/deep/,局部重写
//采用的less的转义和变量插值,深度作用选择器（ >>> ）
// @deep: ~'>>>'*/
</style>